import { createSvgIcon } from '@mui/material';

export const CheckUnderlineCircle = createSvgIcon(
  <path d="M12.2 2a10.2 10.2 0 1 0 10.2 10.2A10.2 10.2 0 0 0 12.2 2m0 18.356a8.158 8.158 0 1 1 8.156-8.156 8.169 8.169 0 0 1-8.156 8.156m-5.1-5.1h10.2V17.3H7.1v-2.04m3.365-3.875l-1.938-1.94L7.1 10.872l3.365 3.365L17.3 7.4l-1.431-1.423z" />,
  'CheckUnderlineCircle',
);
